<template>
  <div>
    <div v-for="item in dadosPerguntas" :key="item.ID_DRAM_AGRUPA_PERGUNTAS" class="grupo-table">
      <div>
        <div class="header">
          <h3>{{ item.DESCRICAO }}</h3>
          <b-button-group class="ml-3">
            <p class="h6 mb-2">
              <b-icon
                v-b-tooltip.hover
                title="Editar"
                variant="primary"
                icon="pencil-fill"
                @click="abrirModalEditarAgrupamento(item)"
              ></b-icon>
            </p>
            <p class="h6 mb-2">
              <b-icon
                v-b-tooltip.hover
                title="Excluir/Inativar"
                class="ml-2"
                @click="abrirModalExcluirAgrupamento(item)"
                variant="danger"
                icon="trash-fill"
              ></b-icon>
            </p>
          </b-button-group>
        </div>
        <b-table
          :items="item.PERGUNTAS_RESPOSTAS"
          :fields="fields"
          primary-key="ID_DRAM_PERGUNTAS_RESPOSTAS"
          responsive
          stacked="md"
          :current-page="currentPage"
          show-empty
          :small="true"
          select-mode="multi"
          :bordered="false"
          striped
          hover
          :tbody-tr-class="rowClass"
          empty-text="Nenhuma Pergunta e Resposta Cadastrada"
          empty-filtered-text="Tente novamente mais tarde. Erro inesperado para carregar as perguntas."
          summary="Tabela de Perguntas e Respostas"
        >
          <template #cell(PERGUNTA)="row">
            {{ row.value }}
          </template>
          <template #cell(RESPOSTA)="row">
            {{ row.value }}
          </template>
          <template #cell(acao)="row">
            <b-button-group>
              <p class="h6">
                <b-icon
                  class="mt-3"
                  v-b-tooltip.hover
                  title="Editar"
                  variant="primary"
                  icon="pencil-fill"
                  @click="abrirModalEditarPergunta(row.item)"
                ></b-icon>
              </p>
              <p class="h6">
                <b-icon
                  class="mt-3 ml-2"
                  v-b-tooltip.hover
                  title="Excluir/Inativar"
                  @click="abrirModalExcluirPergunta(row.item)"
                  variant="danger"
                  icon="trash-fill"
                ></b-icon>
              </p>
            </b-button-group>
          </template>
        </b-table>
      </div>
    </div>
    <b-modal id="modal-editar" title="Editar Agrupamento" ref="modalEditarAgrupamento" hide-footer
      modal-class="large-modal" centered @hidden="resetModal">
      <form ref="form" @submit.prevent="editarItem">
        <b-form-group
          label="Título Agrupamento"
          label-for="pergunta-input"
          invalid-feedback="Pergunta is required"
          :state="itemSelecionado.agrupamentoState"
        >
          <b-form-textarea
            id="pergunta-input"
            v-model="itemSelecionado.nomeAgrupamento"
            :state="itemSelecionado.agrupamentoState"
            required
            rows="4"
          ></b-form-textarea>
        </b-form-group>
        <b-button type="submit" variant="primary" class="ml-3 mr-3 float-right"
          >Atualizar</b-button
        >
        <b-button variant="secondary" class="float-right" @click="limparCampos"
          >Limpar</b-button
        >
      </form>
    </b-modal>
    <b-modal
      id="modal-editar"
      title="Editar Pergunta/Resposta"
      ref="modalEditarPergunta"
      hide-footer
      size="sm"
      modal-class="large-modal"
      centered
      @hidden="resetModal"
    >
      <form ref="form" @submit.prevent="editarItem">
        <b-form-group
          label="Pergunta"
          label-for="pergunta-input"
          invalid-feedback="Pergunta is required"
          :state="itemSelecionado.perguntaState"
        >
          <b-form-textarea
            id="pergunta-input"
            v-model="itemSelecionado.pergunta"
            :state="itemSelecionado.perguntaState"
            required
            rows="4"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group
          label="Resposta"
          label-for="resposta-input"
          invalid-feedback="Resposta is required"
          :state="itemSelecionado.respostaState"
        >
          <b-form-textarea
            id="resposta-input"
            v-model="itemSelecionado.resposta"
            :state="itemSelecionado.respostaState"
            required
            rows="4"
          ></b-form-textarea>
        </b-form-group>
        <b-button type="submit" variant="primary" class="ml-3 mr-3 float-right"
          >Atualizar</b-button
        >
        <b-button variant="secondary" class="float-right" @click="limparCampos"
          >Limpar</b-button
        >
      </form>
    </b-modal>
    <b-modal
      id="modal-excluir"
      modal-class="small-modal"
      centered
      dialog-class="custom-modal"
      variant="primary"
      title="Exclusão da Pergunta/Resposta"
      ref="modalExcluirPergunta"
    >
      <div class="mt-2 text-left mb-5">
        <span class="text-danger mb-3"
          >Confirme a exclusão da pergunta/resposta.</span
        >
      </div>
      <template #modal-footer>
        <div class="d-block text-right">
          <b-button
            variant="danger"
            lg="4"
            class="ml-3 mr-3 float-right"
            @click="excluirItem"
            >Excluir</b-button
          >
          <b-button variant="secondary" class="float-right" @click="fecharModal">Cancelar</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="modal-excluir"
      modal-class="small-modal"
      centered
      dialog-class="custom-modal"
      variant="primary"
      title="Exclusão do Título"
      ref="modalExcluirAgrupamento"
    >
      <div class="mt-2 text-left mb-5">
        <span class="text-danger mb-3">Confirme a exclusão do título, as perguntas e respostas também serão
          excluídas.</span>
      </div>
      <template #modal-footer>
        <div class="d-block text-right">
          <b-button
            variant="danger"
            lg="4"
            class="ml-3 mr-3 float-right"
            @click="excluirItem"
            >Excluir</b-button
          >
          <b-button variant="secondary" class="float-right" @click="fecharModal">Cancelar</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import constantes from "../constants/index";
export default {
  props: {
    dadosPerguntas: Array,
    agrupaPerguntas: Function,
  },
  data() {
    return {
      carregando: false,
      userName: "",
      mensagemSucesso: [],
      mensagemErro: [],
      rowsPerPage: 5,
      pageSizeMenu: [5, 10, 20, 50, 100, 200],
      currentPage: 1,
      fields: [
        { key: "PERGUNTA", label: "PERGUNTA" },
        { key: "RESPOSTA", label: "RESPOSTA" },
        { key: "acao", label: "Ação" },
      ],
      itemSelecionado: {
        pergunta: "",
        resposta: "",
        codAgrupamento: "",
        nomeAgrupamento: "",
        agrupamentoState: null,
        perguntaState: null,
        respostaState: null,
        editarAgrupamento: false,
      },
    };
  },
  methods: {
    editarItem: async function () {
      if (
        this.itemSelecionado.editarAgrupamento === false &&
        !this.checkFormValidity()
      ) {
        return;
      }

      try {
        this.mensagemErro = [];
        this.mensagemSucesso = [];      
        await this.$axios
          .put(this.$env.url_backend + constantes.editarPerguntaResposta, {
            codPerguntaResposta: this.itemSelecionado.codPerguntaResposta,
            pergunta: this.itemSelecionado.pergunta,
            resposta: this.itemSelecionado.resposta,
            codAgrupamento: this.itemSelecionado.codAgrupamento,
            nomeAgrupamento: this.itemSelecionado.nomeAgrupamento,
            editarAgrupamento: this.itemSelecionado.editarAgrupamento,
            userName: this.userName,
          })
          .then((response) => {
            if (response.status === 200) {
              this.mensagemSucesso.push(response.data.message);
              const mensOK = this.mensagemSucesso;
              const data = {
                mensOK,
              };
              this.$emit("mostrarMensagemOK", data);               
              this.agrupaPerguntas();
            }
          });
      } catch (error) {
        this.carregando = false;
        this.mensagemErro.push(error.message);
        window.scrollTo(0, 0);
      }

      // Hide the modal manually
      this.$bvModal.hide("modal-editar");
    },
    excluirItem: async function () {
      try {
        this.mensagemErro = [];
        this.mensagemSucesso = [];
        await this.$axios
          .put(this.$env.url_backend + constantes.inativarPerguntaResposta, {
            codPerguntaResposta: this.itemSelecionado.codPerguntaResposta,
            codAgrupamento: this.itemSelecionado.codAgrupamento,
            userName: this.userName,
          })
          .then((response) => {
            if (response.status === 200) {
              this.mensagemSucesso.push(response.data.message);
              const mensOK = this.mensagemSucesso;
              const data = {
                mensOK,
              };
              this.$emit("mostrarMensagemOK", data);              
              this.agrupaPerguntas();
            }
          });
      } catch (error) {
        this.carregando = false;
        this.mensagemErro.push(error.message);
        window.scrollTo(0, 0);
      }

      // Hide the modal manually
      this.$bvModal.hide("modal-excluir");
    },
    abrirModalEditarAgrupamento(item) {
      this.itemSelecionado = {
        codPerguntaResposta: "",
        pergunta: "",
        resposta: "",
        codAgrupamento: item.ID_DRAM_AGRUPA_PERGUNTAS,
        nomeAgrupamento: item.DESCRICAO,
        agrupamentoState: null,
        perguntaState: null,
        respostaState: null,
        editarAgrupamento: true,
      };
      this.$refs.modalEditarAgrupamento.show();
    },
    abrirModalEditarPergunta(item) {
      this.itemSelecionado = {
        codPerguntaResposta: item.ID_DRAM_PERGUNTAS_RESPOSTAS,
        pergunta: item.PERGUNTA,
        resposta: item.RESPOSTA,
        codAgrupamento: item.ID_DRAM_AGRUPA_PERGUNTAS,
        nomeAgrupamento: item.DESCRICAO,
        agrupamentoState: null,
        perguntaState: null,
        respostaState: null,
        editarAgrupamento: false,
      };
      this.$refs.modalEditarPergunta.show();
    },
    abrirModalExcluirAgrupamento(item) {
      this.itemSelecionado = {
        codAgrupamento: item.ID_DRAM_AGRUPA_PERGUNTAS,
        editarAgrupamento: true,
      };      
      this.$refs.modalExcluirAgrupamento.show();
    },
    abrirModalExcluirPergunta(item) {     
      this.itemSelecionado = {
        codPerguntaResposta: item.ID_DRAM_PERGUNTAS_RESPOSTAS,
        editarAgrupamento: false,
      };
      this.$refs.modalExcluirPergunta.show();
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.ID_CATEGORIA_PARCTO === 9) return "table-warning";
    },
    limparCampos() {
      this.resetModal();
    },
    resetModal() {
      this.itemSelecionado.pergunta = "";
      this.itemSelecionado.resposta = "";
      this.itemSelecionado.codAgrupamento = "";
      this.itemSelecionado.editarAgrupamento = "";
      this.itemSelecionado.nomeAgrupamento = "";
      this.itemSelecionado.perguntaState = null;
      this.itemSelecionado.respostaState = null;
      this.itemSelecionado.agrupamentoState = null;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.itemSelecionado.perguntaState = valid;
      this.itemSelecionado.respostaState = valid;
      return valid;
    },
    fecharModal() {
      this.$bvModal.hide("modal-excluir");
    },
  },
  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
  },
};
</script>

<style scoped>
.table-sm td {
  padding: 0rem;
}

.header {
  display: flex;
}

.grupo-table {
  padding-bottom: 3rem;
}

::v-deep .small-modal .modal-dialog {
  width: 30%;
  max-width: 50%;
}

::v-deep .modal-dialog {
  width: 95%;
  max-width: 100%;
}
</style>
